import removeTrailingOrLeadingCharacter from '../../utils/removeTrailingOrLeadingCharacter';
import removeSubstring from '../../utils/removeSubstring';

export function cleanAddressOrUnitNumber(
  repliersNumberString: string | null,
): string {
  if (repliersNumberString === null) return '';
  let transformed = removeTrailingOrLeadingCharacter(repliersNumberString, ' '); // Clear leading/trailing whitespaces
  transformed = removeTrailingOrLeadingCharacter(transformed, '*'); // Remove any leading/trailing asterisks
  transformed = removeTrailingOrLeadingCharacter(transformed, ' '); // Clear leading/trailing whitespaces
  transformed = removeTrailingOrLeadingCharacter(transformed, '&'); // Remove any leading/trailing ampersands
  transformed = removeTrailingOrLeadingCharacter(transformed, ' '); // Clear leading/trailing whitespaces
  transformed = removeTrailingOrLeadingCharacter(transformed, '-'); // Remove any leading/trailing dashes
  transformed = removeTrailingOrLeadingCharacter(transformed, ' '); // Clear leading/trailing whitespaces
  transformed = removeTrailingOrLeadingCharacter(transformed, ','); // Remove any leading/trailing commas
  transformed = removeTrailingOrLeadingCharacter(transformed, ' '); // Clear leading/trailing whitespaces
  transformed = removeSubstring(transformed, '#'); // Remove any # signs
  transformed = removeSubstring(transformed, 'units'); // Remove the word 'units' (case-insensitive)
  transformed = removeSubstring(transformed, 'unit'); // Remove the word 'unit' (case-insensitive)
  return removeTrailingOrLeadingCharacter(transformed, ' '); // Clear leading/trailing whitespaces
}
